
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 11.5h-2l-3 3v-3h-1a1 1 0 01-1-1v-9a1 1 0 011-1h12a1 1 0 011 1v9","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.5 10.5h6a1 1 0 011 1v8a1 1 0 01-1 1h-1v3l-3-3h-8a1 1 0 01-1-1v-8a1 1 0 011-1h1m-6-2V4a1.5 1.5 0 013 0v4.5m-3-3h3m9 8v-1m-3 1h6M16 13.5a4.868 4.868 0 004 4.5M19 13.5a4.868 4.868 0 01-4 4.5","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    